import { MutationTree } from "vuex";
import { CompanyState, UBO } from "../types";

const mutations: MutationTree<CompanyState> = {
  addUBO(state, payload: UBO) {
    state.ubos.push(payload);
  },
  removeUBO(state, index: number) {
    state.ubos.splice(index, 1);
  },
};

export default mutations;
